var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tf-table"},[_c('Table',{ref:"dragable",attrs:{"loading":_vm.loading,"columns":_vm.columnsList,"data":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }